import { FC, useEffect } from 'react';
import { Box } from '@altermaind/web/ui';
import { Chips } from '@/_shared/components/Chips';
import { getTemplatesCall } from '../../state';

type Props = {
  setActiveChip: (chip: string) => void;
  activeChip: string;
};

export const ChipsTemplate: FC<Props> = ({ setActiveChip, activeChip }) => {
  const { chipsList } = getTemplatesCall.hook();

  useEffect(() => {
    if (chipsList.length > 0 && activeChip === '' && !activeChip) {
      setActiveChip(chipsList[0] || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (chipsList.length === 0) {
    return null;
  }

  return (
    <Box mt='s' mb='m' display='flex' flexDirection='row'>
      <Chips setActiveChip={setActiveChip} activeChip={activeChip} data={chipsList} />
    </Box>
  );
};
